<template>
    <div class="head-title primary-text-32">
       {{propsData.title}}
    </div>
</template>

<script>
// import { initData } from "@/components/mixins"
export default {
    name: 'thsTitle',
    data () {
        return {
        }
    },
    props:{
        propsData:{
            type: Object,
            default(){
                return {
                    title: "白马股频频爆雷私募紧急排雷标题内容标题内容标题内容标题内容标题内容标题" 
                }
            }
        }
    },
    computed: {
    },
    // mixins: [initData],
    beforeCreate: function () {
    },
    created: function () {
    },
    mounted: function () {
    },
    methods: {
    }
}
</script>

<style lang="less" scoped>
@import '../../common/style/common-color.less';
.head-title{
    width:100%;
    font-size: 24px;
    line-height: 36px;
    margin-bottom: 12px;
}
</style>
